import { createContext, useContext, type ReactNode } from 'react'
import { WalletStateStatus } from 'shared/constants'

export interface WalletState {
  isReady: boolean
  isChainIdValid: boolean
  isConnected: boolean
  title: string | null
  handlePrepareWallet: () => Promise<void>
  loading: boolean
  walletStateKey: WalletStateStatus | null
}

const WalletStateContext = createContext<WalletState | null>(null)

export function useWalletStateContext(): WalletState {
  const value = useContext(WalletStateContext)
  if (value == null) {
    throw new Error('useWallet must be used within a WalletStateProvider')
  }
  return value
}

export const WalletStateContextProvider = WalletStateContext.Provider
export { WalletStateContext }
